class Glossary {
  static DEFAULT_ALPHABET = [
    ..."ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    ..."АБВГҐДЕЄЖЗИІЇЙКЛМНОПРСТУФХЦЧШЩЬЮЯ",
  ];

  constructor(
    apiUrl,
    blogHandle,
    blogUrl,
    articlesPerPage = 250,
    alphabet = Glossary.DEFAULT_ALPHABET,
  ) {
    this.apiUrl = apiUrl;
    this.blogHandle = blogHandle;
    this.blogUrl = blogUrl;
    this.articlesPerPage = articlesPerPage;
    this.alphabet = alphabet;
    this.itemsPerColumn = 10;
    this.showMoreLabel = "Показати більше";
    this.showLessLabel = "Згорнути";
    this.articles = [];
    this.hasNextPage = true;
    this.endCursor = null;
  }

  async fetchArticles(first = this.articlesPerPage, after = null) {
    const query = `
      query GetArticles($handle: String!, $first: Int!, $after: String) {
        blog(handle: $handle) {
          articles(first: $first, after: $after, sortKey: TITLE) {
            edges {
              node {
                id
                title
                handle
              }
            }
            pageInfo {
              hasNextPage
              endCursor
            }
          }
        }
      }
    `;

    const variables = { handle: this.blogHandle, first, after };

    try {
      const response = await fetch(this.apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ query, variables }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status ${response.status}`);
      }

      const responseBody = await response.json();

      if (responseBody.errors) {
        throw new Error(
          `GraphQL error: ${JSON.stringify(responseBody.errors)}`,
        );
      }

      if (!responseBody.data || !responseBody.data.blog) {
        throw new Error(
          `Blog "${this.blogHandle}" not found - check the handle and the API url`,
        );
      }

      const articlesData = responseBody.data.blog.articles;
      const articles = articlesData.edges.map((edge) => edge.node);
      const pageInfo = articlesData.pageInfo;

      return { articles, pageInfo };
    } catch (error) {
      console.error("Error fetching articles: ", error);
      return {
        articles: [],
        pageInfo: { hasNextPage: false, endCursor: null },
      };
    }
  }

  async fetchAllArticles() {
    while (this.hasNextPage) {
      const { articles, pageInfo } = await this.fetchArticles(
        this.articlesPerPage,
        this.endCursor,
      );
      this.articles.push(...articles);
      this.hasNextPage = pageInfo.hasNextPage;
      this.endCursor = pageInfo.endCursor;
    }
  }

  letterOf(title) {
    if (!title) return null;
    const match = title.match(/\p{L}/u);
    if (!match) return null;
    const firstLetter = match[0]
      .toUpperCase()
      .normalize("NFKD")
      .replace(/[\u0300-\u036f\u1ab0-\u1aff\ufe20-\ufe2f]/g, "");
    return this.alphabet.includes(firstLetter) ? firstLetter : null;
  }

  CreateGlossaryContainer(
    mainClass = "glossary-blog-posts",
    letterClass = "glossary-blog-posts-post",
    articlesClass = "glossary-blog-posts-post-articles",
  ) {
    const letters = this.alphabet;
    const glossaryContainer = document.querySelector(`.${mainClass}`);

    letters.forEach((letter) => {
      const letterContainer = document.createElement("div");
      letterContainer.classList.add(letterClass);

      letterContainer.dataset.letter = letter;
      letterContainer.innerHTML = `
        <h2 class="${letterClass}-title">${letter}</h2>
        <div class="${articlesClass}"></div>`;
      glossaryContainer.appendChild(letterContainer);
    });
  }

  populateGlossary(
    articleClass = "glossary-blog-posts-post-articles-article",
    containerClass = "glossary-blog-posts-post-articles",
    letterClass = "glossary-blog-posts-post",
  ) {
    this.articles.forEach((article) => {
      const letter = this.letterOf(article.title);
      if (!letter) return;

      const section = document.querySelector(`[data-letter="${letter}"]`);
      if (!section) return;

      const articleElement = document.createElement("a");
      articleElement.classList.add(articleClass);
      articleElement.href = `${this.blogUrl}/${article.handle}`;
      articleElement.textContent = article.title;
      section.querySelector(`.${containerClass}`).appendChild(articleElement);
    });

    document.querySelectorAll(`.${letterClass}`).forEach((letCon) => {
      const articlesContainer = letCon.querySelector(`.${containerClass}`);
      if (!articlesContainer || articlesContainer.children.length === 0) {
        letCon.remove();
      }
    });

    const menuSelector =
      ".glossary-blog-alphabet-letter, .glossary-blog-alphabet-mobile-slider-letter";
    document.querySelectorAll(menuSelector).forEach((mLetter) => {
      if (mLetter.classList.contains("all")) return;
      const letter = mLetter.textContent.trim();
      mLetter.dataset.menuLetter = letter;
      if (document.querySelector(`[data-letter="${letter}"]`)) {
        mLetter.classList.remove("false");
      }
    });
  }

  setupShowMore(
    containerClass = "glossary-blog-posts-post-articles",
    articleClass = "glossary-blog-posts-post-articles-article",
  ) {
    const limit = this.itemsPerColumn;
    if (!limit || limit < 1) return;

    document.querySelectorAll(`.${containerClass}`).forEach((container) => {
      const articles = Array.from(
        container.querySelectorAll(`.${articleClass}`),
      );
      if (articles.length <= limit) return;

      const hidden = articles.slice(limit);
      hidden.forEach((a) => a.classList.add("is-hidden"));

      const button = document.createElement("button");
      button.type = "button";
      button.className = `${containerClass}-show-more`;
      button.textContent = this.showMoreLabel;
      button.setAttribute("aria-expanded", "false");

      button.addEventListener("click", () => {
        const expanded = button.getAttribute("aria-expanded") === "true";
        hidden.forEach((a) => a.classList.toggle("is-hidden", expanded));
        button.setAttribute("aria-expanded", String(!expanded));
        button.textContent = expanded ? this.showMoreLabel : this.showLessLabel;
      });

      container.insertAdjacentElement("afterend", button);
    });
  }

  async displayArticles(
    mainContainer,
    letterContainer,
    articlesContainer,
    articleElement,
  ) {
    await this.fetchAllArticles();
    this.CreateGlossaryContainer(
      mainContainer,
      letterContainer,
      articlesContainer,
    );
    this.populateGlossary(articleElement, articlesContainer, letterContainer);
    this.setupShowMore(articlesContainer, articleElement);
  }
}

const glossary = new Glossary(
  "https://startupecommerce.com.ua/api/2026-07/graphql.json",
  "glossary",
  "https://startupecommerce.com.ua/blogs/glossary",
  250,
);
